import { FieldRender } from "@/lib/types";
import { FormLabel } from "../ui/form";
import { Button } from "../ui/button";
import {
  AlignCenterHorizontalIcon,
  AlignCenterVerticalIcon,
  AlignEndHorizontalIcon,
  AlignEndVerticalIcon,
  AlignHorizontalSpaceAroundIcon,
  AlignHorizontalSpaceBetweenIcon,
  AlignStartHorizontalIcon,
  AlignStartVerticalIcon,
  AlignVerticalSpaceAroundIcon,
  AlignVerticalSpaceBetweenIcon,
  StretchHorizontalIcon,
  StretchVerticalIcon,
} from "lucide-react";

export const FieldJustifyContent: FieldRender<{
  direction: "Row" | "Column";
}> = ({ field, title, direction }) => {
  return (
    <div className="flex gap-2">
      <FormLabel className="flex-grow">{title}</FormLabel>
      <div className="grid flex-shrink-0 grid-cols-3 grid-rows-2">
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "start" ? "default" : "secondary"}
          onClick={() => field.onChange("start")}
        >
          {direction === "Row" ? (
            <AlignStartVerticalIcon />
          ) : (
            <AlignStartHorizontalIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "center" ? "default" : "secondary"}
          onClick={() => field.onChange("center")}
        >
          {direction === "Row" ? (
            <AlignCenterVerticalIcon />
          ) : (
            <AlignCenterHorizontalIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "end" ? "default" : "secondary"}
          onClick={() => field.onChange("end")}
        >
          {direction === "Row" ? (
            <AlignEndVerticalIcon />
          ) : (
            <AlignEndHorizontalIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "space-between" ? "default" : "secondary"}
          onClick={() => field.onChange("space-between")}
        >
          {direction === "Row" ? (
            <AlignHorizontalSpaceBetweenIcon />
          ) : (
            <AlignVerticalSpaceBetweenIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "space-around" ? "default" : "secondary"}
          onClick={() => field.onChange("space-around")}
        >
          {direction === "Row" ? (
            <AlignHorizontalSpaceAroundIcon />
          ) : (
            <AlignVerticalSpaceAroundIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "stretch" ? "default" : "secondary"}
          onClick={() => field.onChange("stretch")}
        >
          {direction === "Row" ? (
            <StretchHorizontalIcon />
          ) : (
            <StretchVerticalIcon />
          )}
        </Button>
      </div>
    </div>
  );
};
